import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '';

let supabase;
try {
  supabase = createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseKey || 'placeholder-key',
    {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
      },
    }
  );
} catch {
  supabase = {
    auth: {
      getSession: async () => ({ data: { session: null } }),
      signInWithOAuth: async () => ({
        error: { message: 'Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY.' },
      }),
      exchangeCodeForSession: async () => ({ data: { session: null }, error: { message: 'Supabase not configured' } }),
      setSession: async () => ({ data: { session: null }, error: { message: 'Supabase not configured' } }),
    },
  };
}

export { supabase };
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);
